import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { IncentivesEntities } from 'client/data/models/incentives';
import { INCENTIVE_HEAD_TITLES, INCENTIVE_OTHER_HEAD_TITLES } from 'site-modules/shared/constants/incentives';
import { getPriceString } from 'site-modules/shared/utils/price-utils';

export function IncentiveOtherInfo({
  incentive: { startDate, endDate, rebateAmount, type } = {},
  titleType,
  isLast = false,
}) {
  const titles = get(INCENTIVE_HEAD_TITLES, titleType, []);
  const hasRebate = ['OTHER_OFFERS', 'NON_CASH_TO_CUSTOMER'].includes(type) && !!rebateAmount;
  const headTitle = INCENTIVE_OTHER_HEAD_TITLES[type];

  return (
    <Fragment>
      <Row tag="dl" noGutters className="mb-0">
        {hasRebate ? (
          <Col xs={12} md={3}>
            <dt className="fw-medium">{headTitle}</dt>
            <dd className="fw-bold">{getPriceString(rebateAmount)}</dd>
          </Col>
        ) : (
          <Col className="d-none d-md-block" md={6} />
        )}
        <Col xs={6} md={{ size: 3, offset: hasRebate ? 3 : 0 }}>
          <dt className="fw-medium">{titles[1]}</dt>
          <dd>{startDate}</dd>
        </Col>
        <Col xs={6} md={3}>
          <dt className="fw-medium">{titles[2]}</dt>
          <dd>{endDate}</dd>
        </Col>
      </Row>
      {!isLast && <hr />}
    </Fragment>
  );
}

IncentiveOtherInfo.propTypes = {
  incentive: IncentivesEntities.IncentiveGraphql,
  titleType: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
};
